import * as actionType from "./ActionTypes";

export default function InvoicePackingDocReducers(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.LOAD_INVOICE_PACKING_DOC:
      return (state = payload);
    case actionType.DELETE_INVOICE_PACKING_DOC:
      var finalData = []
      for (let i = 0; i < state.length; i++) {
        if(state[i].ID !== payload){
          finalData.push(state[i])
        }        
      }
      return finalData
    default: 
      return  state;
  }
}
